export const HANDICAP_MAX_NEGATIVE = "Maximum handicap must be 0 or greater.";
export const HANDICAP_BASE_REQUIRED = "Handicap Base is required.";
export const HANDICAP_PERCENTAGE_REQUIRED = "Handicap Percentage is required.";
export const HANDICAP_PERCENTAGE_POSITIVE =
  "Enter a percentage greater than 0, or choose Scratch.";

const hasValue = (value) => value !== "" && value != null;

/** Empty maximum handicap is allowed (no cap). */
export const handicapMaxError = (handicapMax) => {
  if (!hasValue(handicapMax)) return "";
  const n = Number(handicapMax);
  if (!Number.isFinite(n)) return "";
  if (n < 0) return HANDICAP_MAX_NEGATIVE;
  return "";
};

export const handicapFormErrors = ({
  scoringType,
  handicapBase,
  handicapPercentage,
  handicapMax,
}) => {
  if (scoringType === "scratch") {
    return { handicapBase: "", handicapPercentage: "", handicapMax: "" };
  }
  const errors = {
    handicapBase: hasValue(handicapBase) ? "" : HANDICAP_BASE_REQUIRED,
    handicapPercentage: "",
    handicapMax: handicapMaxError(handicapMax),
  };
  if (!hasValue(handicapPercentage)) {
    errors.handicapPercentage = HANDICAP_PERCENTAGE_REQUIRED;
  } else if (Number(handicapPercentage) <= 0) {
    errors.handicapPercentage = HANDICAP_PERCENTAGE_POSITIVE;
  }
  return errors;
};
